import { z } from 'zod'

const errorMessages = {
  required: 'Este campo é obrigatório',
  invalidEmail: 'Email inválido',
  invalidPhone: 'Telefone inválido',
  minLength: (min: number) => `Deve ter pelo menos ${min} caracteres`,
  maxLength: (max: number) => `Deve ter no máximo ${max} caracteres`,
}

export const ownerSchema = z.object({
  name: z
    .string({ required_error: errorMessages.required })
    .min(2, errorMessages.minLength(2))
    .max(100, errorMessages.maxLength(100)),
  email: z
    .string({ required_error: errorMessages.required })
    .email(errorMessages.invalidEmail),
  phone: z
    .string()
    .optional()
    .refine((val) => !val || val.length >= 10, {
      message: errorMessages.invalidPhone,
    }),
})

export type OwnerFormData = z.input<typeof ownerSchema>
